import React from "react";

function Technologies(props) {
  return props.technologies.map((tech) => (
    <span className="bg-cool-300 text-white md:text-sm text-xs font-thin px-5 py-2 rounded-full">
      {tech}
    </span>
  ));
}

export default Technologies;
